(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shop-header"]) return;
  try {
    
  /*
    EINZIGER Client-Anteil der Shop-Kopfzeile, und eine bewusste Ergaenzung
    zum JS-freien Grundgeruest — begruendet analog zum Filter-Drawer in
    SHOP_SPEC.md Abschnitt 10.4.

    Auf und Zu des mobilen Menues macht <details> selbst, ohne JavaScript.
    Was <details> NICHT kann: sich schliessen, wenn ein Link IM Panel
    angetippt wird und die Navigation die Seite nicht verlaesst. Genau das
    passiert bei den Sprungmarken der Shop-Navigation (/#bestseller,
    /#fragen): die Seite springt, das Panel bleibt offen ueber dem Inhalt
    stehen. Der Prototyp haengt dafuer an jedem Link ein onClick={close}
    (HeaderMobileMenu.tsx); <details> hat kein Pendant, weil es nur auf das
    <summary> reagiert.

    Ohne JavaScript bleibt das Panel offen — unschoen, aber nicht kaputt:
    der Nutzer kann es ueber die Schliessen-Steuerung zumachen, und die
    Navigation selbst funktioniert. Deshalb Progressive Enhancement und
    keine Voraussetzung.

    Delegiert am document, damit es unabhaengig davon greift, wann Shopify
    die Sektion neu rendert (Theme-Editor).
  */
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.arbach-shopnav-drawer__link');
    if (!link) return;
    var panel = link.closest('details');
    if (panel) panel.open = false;
  });

  /*
    Der kompakte Kopf beim Scrollen (Auftrag 20, B1: Klasse .is-kompakt,
    margin-bottom-Ausgleich, Plakette über data-zahl) ist mit Auftrag 25
    entfallen — unter 1024 px ist der Kopf jetzt immer einzeilig, und die
    Plakette rendert Liquid direkt (.arbach-shophead__zahl).
  */

  } catch(e) { console.error(e); }
})();
})();
